import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Form, Input, Button, Card, Typography, App, Space } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { trpc } from '../../lib/api';
import { useAgencyAuthStore } from '../../stores/agencyAuthStore';
import { SERVICE_TITLE } from '@shared/config/service-config';

const { Title, Text } = Typography;

interface AgencyLoginForm {
  email: string;
  password: string;
}

export function AgencyLoginPage() {
  const { message: messageApi } = App.useApp();
  const navigate = useNavigate();
  const { setAuth } = useAgencyAuthStore();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const loginMutation = trpc.agencyAuth.login.useMutation({
    onSuccess: (data) => {
      setAuth(data.agencyUser, data.token, data.expiresAt);
      messageApi.success('ログインに成功しました');
      setLoading(false);
      navigate('/agency/dashboard', { replace: true });
    },
    onError: (error: unknown) => {
      const errorMessage = error instanceof Error
        ? error.message
        : 'ログインに失敗しました';
      messageApi.error(errorMessage);
      setLoading(false);
    },
  });

  const handleSubmit = async (values: AgencyLoginForm) => {
    setLoading(true);
    loginMutation.mutate(values);
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '20px',
      }}
    >
      <Card
        style={{
          width: '100%',
          maxWidth: '400px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
        }}
      >
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div style={{ textAlign: 'center' }}>
            <Title level={2} style={{ marginBottom: '8px' }}>
              代理店ポータル
            </Title>
            <Text type="secondary">{SERVICE_TITLE}</Text>
          </div>

          <Form
            form={form}
            name="agencyLogin"
            onFinish={handleSubmit}
            layout="vertical"
            size="large"
          >
            <Form.Item
              name="email"
              rules={[
                { required: true, message: 'メールアドレスを入力してください' },
                { type: 'email', message: '有効なメールアドレスを入力してください' },
              ]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="メールアドレス"
                autoComplete="username"
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[{ required: true, message: 'パスワードを入力してください' }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="パスワード"
                autoComplete="current-password"
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                block
                size="large"
              >
                ログイン
              </Button>
            </Form.Item>
          </Form>

          <div style={{ textAlign: 'center' }}>
            <Space direction="vertical" size="small">
              <Link to="/">
                <Text type="secondary">トップページに戻る</Text>
              </Link>
              <Link to="/login">
                <Text type="secondary">通常ログインはこちら</Text>
              </Link>
            </Space>
          </div>
        </Space>
      </Card>
    </div>
  );
}
